export default "__VITE_ASSET__C63LSrZs__"